/**
 * Spacing Tokens
 * Consistent spacing scale based on 4px grid system.
 * Use for margins, paddings, and gaps.
 */

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  '2xl': '32px',
  '3xl': '40px',
  '4xl': '56px',
  '5xl': '72px',
  '6xl': '96px',
  '7xl': '120px',
  '8xl': '160px',
  '9xl': '200px',
  '10xl': '240px',
} as const;

export type SpacingKey = keyof typeof spacing;

/**
 * Border radius tokens
 * Consistent border radius for components
 */
export const borderRadius = {
  none: '0',
  sm: '4px',
  md: '8px',
  lg: '16px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '32px',
  full: '9999px',
} as const;

/**
 * Blur tokens
 * Centralized blur radii for glass effects
 */
export const blur = {
  none: '0',
  light: '12px',
  glass: '20px',
  heavy: '32px',
} as const;

